<template>
    <div class="user_payouts" v-loading="loading">
        <div class="payouts_titles">奖励提现</div>
        <div class="payouts_info">
            <div class="payouts_info_title">发票抬头（购买方）</div>
            <div class="payouts_info1"><span>公司名称：</span>广州淼燊商业管理有限公司</div>
            <div class="payouts_info2"><span>税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：</span>91440101MA5D6U3W3Y</div>
            <div class="payouts_border"></div>
            <div class="payouts_tx_text">提现规则说明</div>
        </div>
        <div class="payouts_form">
            <div class="payouts_form_top">
                <div class="top_bor"></div>
                <div class="top_text">奖励提现</div>
            </div>
            <div class="form_box">
                <div class="form_tite">
                    <span>*</span>
                     提现金额
                </div>
                <div class="form_input">
                    <el-input type="number" v-model.number="form.money" placeholder="请输入"></el-input>

                </div>
                <div class="form_ts">
                    可提现奖励：<span>{{ money }}</span>
                </div>
            </div>

            <div class="form_box">
                <div class="form_tite">
                    <span>*</span>
                     姓名
                </div>
                <div class="form_input">
                    <el-input v-model="form.name" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="form_box">
                <div class="form_tite">
                    <span>*</span>
                      手机号
                </div>
                <div class="form_input">
                    <el-input v-model="form.mobile" placeholder="请输入"></el-input>
                </div>
            </div>

            <div class="form_box">
                <div class="form_tite">
                    <span>*</span>
                     身份张类型
                </div>
                <div class="form_input">
                   <el-select v-model="form.certificate_type" placeholder="请选择">
                    <!-- 1身份证 2护照 3其他 -->
                        <el-option label="身份证" :value="1">
                        </el-option>
                        <el-option label="护照" :value="2">
                        </el-option>
                          <el-option label="其他" :value="3">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="form_box">
                <div class="form_tite">
                    <span>*</span>
                      身份张/护照号
                </div>
                <div class="form_input">
                    <el-input v-model="form.id_number" placeholder="请输入"></el-input>
                </div>
            </div>

            <div class="form_box">
                <div class="form_tite">
                    <span>*</span>
                    提现方式
                </div>
                <div class="form_input">
                   <el-select v-model="form.tx_type" placeholder="请选择">
                        <el-option label="支付宝" :value="1">
                        </el-option>
                        <el-option label="银行卡" :value="2">
                        </el-option>

                    </el-select>
                </div>
            </div>
             <div class="form_box" v-if="form.tx_type==1">
                <div class="form_tite">
                    <span>*</span>
                      支付宝账号
                </div>
                <div class="form_input">
                    <el-input v-model="form.zfb" placeholder="请输入"></el-input>
                </div>
            </div>
            
            <div class="form_box" v-if="form.tx_type==2">
                <div class="form_tite">
                    <span>*</span>
                       开户银行
                </div>
                <div class="form_input">
                    <el-input v-model="form.bank" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="form_box" v-if="form.tx_type==2">
                <div class="form_tite">
                    <span>*</span>
                       银行卡号
                </div>
                <div class="form_input">
                    <el-input v-model="form.bank_num" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="form_box"  >
                <div class="form_tite">
                     
                </div>
                <div class="form_btns">
                    <div class="btns1" @click="handle_end()">提交</div>
                    <div class="btns2" @click="$router.back()">取消</div>
                </div>
            </div>
             <div class="form_box"  >
                <div class="form_tite">
                     
                </div>
                <div class="form_texts">
                    1.提交申请后，可提现的余额就减少，取消提现则余额回滚<br>
                    2.平台管理员生成报盘文件后，不可取消提现申请；<br>
                    3.报盘文件必填项字段不为空（不可违反数据规则），否则不可申请提现。
                </div>
            </div>






        </div>
     
        
    </div>
</template>
<script>
import { mapState} from 'vuex'
 
import user_tab1 from '@/components/user_jl/user_tab1.vue'
import user_tab2 from '@/components/user_jl/user_tab2.vue'
 

export default {
    components: {
        user_tab1,
        user_tab2
    },
    name: "homes",
    data() {
        return {
            loading: false,
            
            money:'',
           



            jl_list:[],
            form:{
                tx_type:1,//1支付宝2银行卡
                money:'',//金额
                name:'',//姓名
                mobile:'',//手机号
                zfb:'',//支付宝账号
                bank:'',//开户银行
                bank_num:'',//银行账号
                fapiao_id:'',//开票id
                certificate_type:1,//1身份证 2护照 3其他
                id_number:'',//身份张/护照号
            },
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_UserInfo()
    },
    methods: {
        handle_end(){
            if(!this.form.money){
                alertErr('请输入提现金额')
                return
            }
            if(!this.form.name){
                alertErr('请输入姓名')
                return
            }
            if(!this.form.mobile){
                alertErr('请输入手机号')
                return
            }
            if(this.form.tx_type==1){
                if(!this.form.zfb){
                    alertErr('请输入支付宝账号')
                    return
                }
            }else{
                if(!this.form.bank){
                    alertErr('请输入开户银行')
                    return
                }
                if(!this.form.bank_num){
                    alertErr('请输入银行账号')
                    return
                }
            }

            this.loading=true
            this.$api("userTx", {
                ...this.form,

			}, "post").then((res) => {
                this.loading = false
                console.log('我的奖励',res)
                if (res.code == 1) {
                     alertSucc('申请成功')
                     this.form={
                        tx_type:1,//1支付宝2银行卡
                        money:'',//金额
                        name:'',//姓名
                        mobile:'',//手机号
                        zfb:'',//支付宝账号
                        bank:'',//开户银行
                        bank_num:'',//银行账号
                        fapiao_id:'',//开票id
                    
                    }
                    this.get_UserInfo()

                } else {
                    alertErr(res.msg)

                }
            });
        },
        
        get_UserInfo(){
            this.loading=true
            this.$api("getUserInfo", {
                
			}, "get").then((res) => {
                this.loading = false
                console.log('我的奖励',res)
                if (res.code == 1) {
                    this.money=res.data.money
                } else {
                    alertErr(res.msg)
                }
            });
        },
      
    },

}
</script>
<style scoped lang="less">
.user_payouts {
    .payouts_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .payouts_info{
        width: 1196px;
        min-height: 393px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 24px;
        padding: 24px 32px;
        .payouts_info_title{
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            margin-bottom: 26px;
 
        }
        .payouts_info1{
            font-weight: 400;
            font-size: 18px;
            color: #333333;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            text-align: right;

            span{
                width: 90px;
            }
        }
        .payouts_info2{
            font-weight: 400;
            font-size: 18px;
            color: #333333;
            display: flex;
            align-items: center;
            span{
                text-align: right;
                width: 90px;
            }
        }
        .payouts_border{
            width: 100%;
            margin-top: 40px;
            border: 1px dashed  #B9B9B9;
        }
        .payouts_tx_text{
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            margin-top: 26px;
            padding-top: 24px;
        }
    }
    .payouts_form{
        margin-top: 24px;
        background-color: #FFFFFF;
        .payouts_form_top{
            height: 56px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #DEDEDE;
            margin-bottom: 40px;
            .top_bor{
                width: 4px;
                height: 22px;
                background: #377CFD;
                border-radius: 3px 3px 3px 3px;
            }
            .top_text{
                font-weight: 400;
                font-size: 18px;
                color: #333333;
                padding-left: 28px;
            }
        }
        .form_box{
            display: flex;
            align-items: center;
            padding-left: 100px;
            margin-bottom: 24px;
            .form_tite{
                width: 120px;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                display: flex;
                align-items: center;
                justify-content: right;
                padding-right: 24px;

                span{
                    color: #FD4C5C;
                }
            }   
            .form_input{
                /deep/.el-input__inner{
                    width: 300px;
                }
            }
            .form_ts{
                display: flex;
                align-items: center;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                padding-left: 34px;
                span{
                    font-weight: 400;
                    font-size: 24px;
                    color: #377CFD;
                }
            }
            .form_btns{
                display: flex;
                align-items: center;
                .btns1{
                    width: 76px;
                    height: 40px;
                    background: #377CFD;
                    border-radius: 4px 4px 4px 4px;
                    line-height: 40px;
                    cursor: pointer;
                    text-align: center;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;

                }
                .btns2{
                    margin-left: 24px;
                    width: 76px;
                    height: 40px;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #377CFD;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #377CFD;

                }
            }
            .form_texts{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #FF9100;
                line-height: 30px;
                padding-bottom: 40px;
            }

        }
    }
}
</style>